import { useCallback, useMemo } from 'react'
import { generateClient } from 'aws-amplify/api'

import { getTeamsByOfferingId as getTeamsByOfferingIdQuery } from '../graphql/queries'

export const useTeamsByOfferingId = () => {
  const client = useMemo(() => generateClient(), [])
  const getTeamsByOfferingId = useCallback(
    (offeringId) => {
      return client.graphql({
        query: getTeamsByOfferingIdQuery,
        variables: { offeringId },
      })
    },
    [client],
  )

  return { getTeamsByOfferingId }
}
